import { useSdk } from '~/sdk';

interface RelatedProductsState {
  data: any;
  loading: boolean;
}

export const useRelatedProducts = () => {
  const key = useKey();

  const state = useState<RelatedProductsState>(
    key.value,
    (): RelatedProductsState => ({
      data: null,
      loading: false,
    }),
  );

  const fetchRelatedProducts = async (params: any) => {
    state.value.loading = true;

    console.log('Fetching related products...');

    const data = await useSdk().commerce.getRelatedProducts({
      id_product: params.id_product,
      page: params.page || 1,
    });

    state.value.data = data;
    state.value.loading = false;

    return data;
  };

  return {
    fetchRelatedProducts,
    ...toRefs(state.value),
  };
};
